// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CommitmentCalculation;
(function (CommitmentCalculation) {
    CommitmentCalculation["HistoricalCommitment"] = "historicalCommitment";
    CommitmentCalculation["RecomputedCommitment"] = "recomputedCommitment";
})(CommitmentCalculation || (CommitmentCalculation = {}));
export function CommitmentCalculationFromJSON(json) {
    return json;
}
export function CommitmentCalculationToJSON(value) {
    return value;
}
